export default function({ data }) {
  // convert the data to the format that the chart expects
  const lines = []

  const placesHash = {}
  data.forEach(d => {
    if (typeof placesHash[d.place] === 'undefined') {
      placesHash[d.place] = []
    }
    placesHash[d.place].push({
      year: d.year,
      realMedianSalesPrice: d.realMedianSalesPrice,
      numberofSales: d.numberofSales
    })
  })

  Object.keys(placesHash).forEach(place => {
    lines.push({
      title: place,
      coordinates: placesHash[place]
    })
  })

  return lines
}
